function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from "react";
import Common from "../components/includes/Common";
import moment from "moment";
import { DatePicker, Space, Table, message, Button, Divider, Form, Tabs, Select } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import { Excel } from "antd-table-saveas-excel";
import { Download, Cash, BuildingFill, BuildingFillGear, PeopleFill } from "react-bootstrap-icons";
import CompanyBills from "../components/CompanyBills";
import InsBills from "../components/InsBills";
import Moment from "react-moment";
import CashierTransactionsList from "./CashierTransactionsList";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var TabPane = Tabs.TabPane;
var UserBills = function UserBills() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    listOfBills = _useState2[0],
    setListOfBills = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    billsArrayData = _useState4[0],
    setBillsArrayData = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isDataLoading = _useState6[0],
    setIsDataLoading = _useState6[1];
  var _useState7 = useState(moment().startOf('day').format()),
    _useState8 = _slicedToArray(_useState7, 2),
    from = _useState8[0],
    setFrom = _useState8[1];
  var _useState9 = useState(moment().endOf('day').format()),
    _useState10 = _slicedToArray(_useState9, 2),
    to = _useState10[0],
    setTo = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    currentUser = _useState12[0],
    setCurrentUser = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    userOptions = _useState14[0],
    setUserOptions = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    userList = _useState16[0],
    setUserList = _useState16[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    dataChanged = _useState18[0],
    setDataChanged = _useState18[1];
  var onSearchFinish = function onSearchFinish(values) {
    setFrom(moment(new Date(values.range[0]._d)).format());
    setTo(moment(new Date(values.range[1]._d)).format());
    setCurrentUser(userList.filter(function (u) {
      return u.id == values.user_id;
    })[0]);
    setDataChanged(true);
  };
  var rangePresets = {
    "Aujourdh'ui": [moment().startOf('day'), moment().endOf('day')],
    'Cette semaine': [moment().startOf('week'), moment().endOf('week')],
    'Ce mois': [moment().startOf('month'), moment().endOf('month')]
  };
  var onChange = function onChange(v) {
    //setCurrentUser(userList.filter(u => u.id == v)[0]);
    console.log(JSON.stringify(currentUser));
  };
  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + "getplatformusers/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setUserOptions([]);
        setUserList(response.data.users.filter(function (u) {
          return u.role == 11 || u.role == 41 || u.role == 71;
        }));
        response.data.users.filter(function (u) {
          return u.role == 11 || u.role == 41 || u.role == 71;
        }).forEach(function (e) {
          setUserOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: e.firstname + " " + e.lastname,
              value: e.id
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  useEffect(function () {
    setDataChanged(false);
  }, [dataChanged]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          children: [/*#__PURE__*/_jsx(Form, {
            size: "large",
            form: form,
            onFinish: onSearchFinish,
            layout: "horizontal",
            children: /*#__PURE__*/_jsxs(Space, {
              direction: "horizontal",
              children: [/*#__PURE__*/_jsx(Form.Item, {
                name: "range",
                rules: [{
                  required: true,
                  message: "Champs obligatoire"
                }],
                children: /*#__PURE__*/_jsx(RangePicker, {
                  ranges: rangePresets,
                  showTime: {
                    format: 'HH:mm'
                  },
                  format: "DD-MM-YYYY HH:mm"
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                name: "user_id",
                rules: [{
                  required: true,
                  message: "Veuillez choisir une caisse"
                }],
                children: /*#__PURE__*/_jsx(Select, {
                  onChange: onChange,
                  options: userOptions,
                  placeholder: "Choisir une caisse"
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Button, {
                  type: "primary",
                  htmlType: "submit",
                  children: /*#__PURE__*/_jsx("b", {
                    children: "RECHERCHE"
                  })
                })
              })]
            })
          }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs("div", {
            style: {
              fontWeight: "bold",
              fontStyle: 'italic'
            },
            children: ["Du ", new Date(from).toLocaleDateString("Fr"), " Au ", new Date(to).toLocaleDateString("Fr")]
          }), /*#__PURE__*/_jsx(CashierTransactionsList, {
            user: currentUser,
            from: from,
            to: to,
            dataChanged: dataChanged
          })]
        })
      })
    })
  });
};
export default UserBills;